import { render } from "./payTypeChoose.vue?vue&type=template&id=3153e72d&scoped=true"
import script from "./payTypeChoose.vue?vue&type=script&lang=js"
export * from "./payTypeChoose.vue?vue&type=script&lang=js"

import "./payTypeChoose.vue?vue&type=style&index=0&id=3153e72d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3153e72d"

export default script